import {
  LOGOUT,
  SET_JOB_DATA,
  SET_JOB_DETAIL_DATA,
  SET_ONLINE_STATUS,
  RESET_ONLINE_STATUS,
} from "../actions/action.types";

const initialOnlineStatus = {
  userId: null,
  isOnline: false,
  lastSeen: null,
};

const initialState = {
  jobs: [],
  jobDetail: undefined,
  onlineStatus: initialOnlineStatus,
};

const jobReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_JOB_DATA:
      return { ...state, jobs: payload };
    case SET_JOB_DETAIL_DATA:
      return { ...state, jobDetail: payload };
    case SET_ONLINE_STATUS:
      return { ...state, onlineStatus: payload };
    case RESET_ONLINE_STATUS:
      return { ...state, onlineStatus: initialOnlineStatus };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default jobReducer;
